import { gql } from '@apollo/client';

const INSERT_AFFILIATES = gql`
  mutation INSERT_AFFILIATE($object: boatnew_affiliates_insert_input!) {
    insert_boatnew_affiliates_one(object: $object) {
      first_name
      last_name
      id
    }
  }
`;
interface INSERT_AFFILIATES_INTERFACE {
  first_name: String;
  last_name: String;
  country: String;
  phone: String;
  bussiness_name: String;
  social_link: String;
  reason: String;
  status: String;
}

export { INSERT_AFFILIATES };
export type { INSERT_AFFILIATES_INTERFACE };
